<template>
  <div id="home">
        <br/>
        <router-link to="/about">About</router-link>
    <br/>
        <br/>
    <img alt="logo" src="../assets/logo.png"><br/>
     <router-link tag="Button" to="/login">Log in <i class="pi pi-sign-in p-m-1"></i></router-link>
     <router-link tag="Button" class="p-ml-3 registerbutton" to="/signup">Sign up <i class="pi pi-user-plus p-m-1"></i></router-link>
    

<p>The <b>food ordering app</b> for The Wilderness Inn Dining Facility!</p>

                   <p class="details">
                <small class="level-item" style="color: var(--textLight)">
              Brought to you by <b>4/25th Soldier-Coders</b>, SPARwerx, and JBER Arctic Spark
                </small>
              </p>


                <router-link to="/forgot"><small>Forgot Password?</small></router-link>
              <p class="details">
                <small class="level-item" style="color: var(--textLight)">
                  &copy; SPARwerx. All Rights Reserved.
                </small>
              </p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
};
</script>

<style lang="scss" scoped>
body,
html,
#app {
  background-color: #BB4a4a;
}

#home {
  font-size: 20px;
}

img {
  width: 200px;
}

.registerbutton {
background-color: #CD4242;
border-color: #CD4242;
}

.registerbutton:enabled:hover, 
.registerbutton:enabled:active {
    background: #CD4242;
    color: white;
    border-color: #CD4242;
}

.registerbutton:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem white;
}
</style>